"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  name: "Sarah Al-Maktoum",
  role: "Operations Director, Marriott International",
  text: "IT Masters delivered a flawless VM infrastructure that powers our entire guest service ecosystem. Their precision and technical depth are unmatched in the UAE market.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/executive_sarah.png"
}, {
  id: 2,
  name: "David Chen",
  role: "CTO, Global Hospitality Group",
  text: "The silent engine behind our digital transformation. Their proactive threat hunting and robust networking solutions have ensured zero downtime for our flagship properties.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/executive_david.png"
}, {
  id: 3,
  name: "Elena Rodriguez",
  role: "Infrastructure Lead, Sheraton Hotels",
  text: "Architecting resilient systems is their specialty. They bridge the gap between complex technology and business efficiency with absolute professional excellence.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/executive_elena.png"
}, {
  id: 4,
  name: "Marcus Thorne",
  role: "IT Procurement Manager, Le Méridien",
  text: "Their strategic IT auditing eliminated redundancies and optimized our annual spend by 30% without compromising on high-performance network standards.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/executive_marcus.png"
}];
export default function CustomerTestimonials() {
  return <section data-section-id="240358" id="client-success-stories" className="relative bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_infrastructure_blueprint.png)] bg-cover bg-center opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-br from-[hsl(222,47%,4%)] via-[hsl(222,47%,6%)] to-[hsl(210,100%,12%)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tighter text-white md:text-4xl lg:text-5xl uppercase">
            Success Stories
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 bg-secondary rounded-md" />
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="mx-auto w-full max-w-6xl">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <div className="h-full p-1">
                  <Card className="h-full bg-white/5 backdrop-blur-xl border-t border-white/20 border-x-white/5 border-b-white/5 shadow-2xl transition-all duration-[400ms] ease-out hover:bg-white/10 hover:-translate-y-1 rounded-md">
                    <CardContent className="flex h-full flex-col justify-between p-8">
                      <div>
                        <div className="mb-6 flex items-center justify-between">
                          <Quote className="size-10 text-secondary/60" />
                          <span className="font-mono text-[10px] uppercase tracking-widest text-secondary border border-secondary/30 px-2 py-1 rounded-md">
                            Enterprise Grade
                          </span>
                        </div>
                        <p className="font-serif text-[18px] italic leading-relaxed text-white/90">
                          "{testimonial.text}"
                        </p>
                      </div>

                      <div className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
                        <SafeHydrate><Avatar className="size-16 border border-primary shadow-lg rounded-md">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.name} className="object-cover" />
                          <AvatarFallback className="bg-muted text-muted-foreground font-mono">
                            {testimonial.name.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div>
                          <h3 className="font-default text-lg font-semibold text-white tracking-tight">
                            {testimonial.name}
                          </h3>
                          <p className="font-mono text-[11px] text-muted-foreground uppercase tracking-wider">
                            {testimonial.role}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="mt-12 flex items-center justify-center gap-4">
            <CarouselPrevious className="static translate-x-0 translate-y-0 bg-white/5 border-white/10 text-white hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all rounded-md" />
            <CarouselNext className="static translate-x-0 translate-y-0 bg-white/5 border-white/10 text-white hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all rounded-md" />
          </div>
        </Carousel>
      </div>
    </section>;
}